import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "buyer" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created");
      navigate(form.role === "seller" ? "/market" : "/");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-[80vh] items-center justify-center px-5 py-12" data-testid="register-page">
      <Seo title="Sign Up — The Hoodie Project®" />
      <div className="w-full max-w-md border border-border p-8 md:p-10">
        <h1 className="font-display text-4xl font-extrabold tracking-tighter">SIGN UP</h1>
        <p className="mt-2 text-sm text-muted-foreground">Shop the drop or open your own resale storefront.</p>

        <div className="mt-6 grid grid-cols-2 gap-0 border border-border">
          <button onClick={() => setForm({ ...form, role: "buyer" })} data-testid="role-buyer"
            className={`py-3 text-xs tracking-widest transition-colors ${form.role === "buyer" ? "bg-white text-black" : "hover:bg-muted"}`}>SHOPPER</button>
          <button onClick={() => setForm({ ...form, role: "seller" })} data-testid="role-seller"
            className={`border-l border-border py-3 text-xs tracking-widest transition-colors ${form.role === "seller" ? "bg-white text-black" : "hover:bg-muted"}`}>SELLER / PARTNER</button>
        </div>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Name or store name" data-testid="register-name"
            className="w-full border border-border bg-black px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-white" />
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" data-testid="register-email"
            className="w-full border border-border bg-black px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-white" />
          <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Password" data-testid="register-password"
            className="w-full border border-border bg-black px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-white" />
          <button type="submit" disabled={loading} data-testid="register-submit"
            className="w-full bg-white py-4 text-xs font-bold tracking-[0.3em] text-black transition-colors hover:bg-neutral-300 disabled:opacity-50">
            {loading ? "…" : "CREATE ACCOUNT"}
          </button>
        </form>
        <p className="mt-6 text-sm text-muted-foreground">Have an account? <Link to="/login" className="text-white underline">Log in</Link></p>
      </div>
    </div>
  );
}
